export default () => window.documentViewer.getDocument().getPrintablePDF();
